var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3534)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#FECA00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2402_3534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2402_3534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#DB501C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37155 10.7905C8.37155 10.7905 8.10426 14.4409 10.5376 14.4409C12.9709 14.4409 12.3515 14.4409 12.3515 14.4409C12.3515 14.4409 14.9113 14.2183 14.6141 10.7905",
    stroke: "#DB501C",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 11.3081C13.2812 12.0287 13.0617 12.6667 12.7247 13.116C12.3878 13.5653 11.9509 13.8081 11.5 13.8081C11.0491 13.8081 10.6122 13.5653 10.2753 13.116C9.93829 12.6667 9.71875 12.0287 9.71875 11.3081C9.71875 10.5875 9.93829 9.94953 10.2753 9.50017C10.6122 9.05094 11.0491 8.80811 11.5 8.80811C11.9509 8.80811 12.3878 9.05094 12.7247 9.50017C13.0617 9.94953 13.2812 10.5875 13.2812 11.3081Z",
    fill: "#FECA00",
    stroke: "#68B9E8",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11.4997C11.897 11.4997 12.2188 11.0706 12.2188 10.5413C12.2188 10.0121 11.897 9.58301 11.5 9.58301C11.103 9.58301 10.7812 10.0121 10.7812 10.5413C10.7812 11.0706 11.103 11.4997 11.5 11.4997Z",
    fill: "#DB501C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5719 13.0333C12.2467 13.0333 12.7937 12.6901 12.7937 12.2667C12.7937 11.8432 12.2467 11.5 11.5719 11.5C10.897 11.5 10.35 11.8432 10.35 12.2667C10.35 12.6901 10.897 13.0333 11.5719 13.0333Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5719 9.58314C12.5246 9.58314 13.2969 9.23989 13.2969 8.81647C13.2969 8.39305 12.5246 8.0498 11.5719 8.0498C10.6192 8.0498 9.84692 8.39305 9.84692 8.81647C9.84692 9.23989 10.6192 9.58314 11.5719 9.58314Z",
    fill: "#674F28"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3534)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3534",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBob);
export default __webpack_public_path__ + "static/media/BOB.1823a9f62a6ff731760dbd50198b0d87.svg";
export { ForwardRef as ReactComponent };